/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { ModalsPrivateLayout } from "../components/modal/ModalsPrivateLayout";
import { PrivateRoute } from "../components/PrivateRoute";
import { RedirectToLoginOnUnauthorized } from "../components/redirectOnUnauthorized";
import { AppRouteUi } from "../config/appRoute";
import { AppUserRoles } from "../config/constants";
import { ApiCompany } from "../core/apis/company";
import { StorageAuth } from "../core/localStorage";
import { useAppSelector } from "../core/redux";
import { useAppDispatch } from "../core/redux/ReduxStore";
import { ActionCompany } from "../core/redux/slices/sliceCompany";
import { useProfileFetchFunc } from "../libs/hooks";
import { Footer } from "./components/footer.component";
import { LeftNav } from "./components/left-nav.component";
import { Nav } from "./components/nav.component";
import { PageAppointment } from "./pages/pageAppointment";
import { PageCaregiver } from "./pages/pageCaregiver/pageCaregiver";
import { PageCheckout } from "./pages/pageChakeout";
import { PageCompany } from "./pages/pageCompany/pageCompany";
import { PageDashboard } from "./pages/pageDashboard/pageDashboard";
import { PageFinanceCaregiver } from "./pages/pageFinance/pageFinanceCaregiver";
import { PageFinancePatient } from "./pages/pageFinance/pageFinancePatient";
import { PageInsurance } from "./pages/pageInsurance";
import { PageInvoice } from "./pages/pageInvoice/pageInvoice";
import { PageNotFound } from "./pages/pageNotFound";
import { PagePatient } from "./pages/pagePatient";
import { PageReport } from "./pages/pageReports";
import { PageSettings } from "./pages/pageSettings";
import { PageTaskList } from "./pages/pageTaskList";
import { PageUsers } from "./pages/pageUsers";
import { PageImport } from "./pages/pageImport";
import {
  PageBilling,
  PageDataExchange,
  PageSuperAdminDataExchange,
  PageHHAConfig,
} from "./pages";

export function LayoutPrivate(): JSX.Element {
  const profile = useProfileFetchFunc();
  const dispatch = useAppDispatch();

  const { isLoggedIn, companyId, userRole } = useAppSelector(
    (state) => state.auth
  );
  React.useEffect(() => {
    profile.fetchProfile();
  }, []);

  useEffect(() => {
    if (isLoggedIn && userRole === AppUserRoles.Admin && companyId) {
      ApiCompany.GetCompanyById(companyId).then((res) => {
        res && dispatch(ActionCompany.setCompany(res));
        StorageAuth.IsAutoClockInEnable = res?.isAutoClockInEnable;
        const subscribed =
          !!res?.subscription?.endDate &&
          new Date(res.subscription?.endDate) > new Date();
        dispatch(ActionCompany.setSubscribed(subscribed));
      });
    }
  }, [companyId, isLoggedIn, userRole]);

  return (
    <RedirectToLoginOnUnauthorized>
      <LeftNav />
      <div className="site-content">
        <div className="container-fluid m-auto p-0">
          <div className="row gx-0">
            <Nav />
            <main className="site-main-content">
              <Switch>
                <PrivateRoute
                  role={AppUserRoles.Admin}
                  path={AppRouteUi.Dashboard.Root()}
                  exact
                  component={PageDashboard}
                />
                <PrivateRoute
                  role={[AppUserRoles.Admin, AppUserRoles.SuperAdmin]}
                  path={AppRouteUi.ManageTaskList.Root()}
                  component={PageTaskList}
                />
                <PrivateRoute
                  role={[AppUserRoles.Admin, AppUserRoles.SuperAdmin]}
                  path={AppRouteUi.Patient.Root()}
                  component={PagePatient}
                />
                <PrivateRoute
                  role={[AppUserRoles.Admin, AppUserRoles.SuperAdmin]}
                  path={AppRouteUi.Caregiver.Root()}
                  component={PageCaregiver}
                />
                <PrivateRoute
                  role={AppUserRoles.Admin}
                  path={AppRouteUi.Appointment.Root()}
                  component={PageAppointment}
                />
                <PrivateRoute
                  role={AppUserRoles.SuperAdmin}
                  path={AppRouteUi.Insurance.Root()}
                  component={PageInsurance}
                />
                <PrivateRoute
                  role={AppUserRoles.SuperAdmin}
                  path={AppRouteUi.Users.Root()}
                  component={PageUsers}
                />
                <PrivateRoute
                  role={[AppUserRoles.Admin, AppUserRoles.SuperAdmin]}
                  path={AppRouteUi.Settings.Root()}
                  component={PageSettings}
                />
                <PrivateRoute
                  role={AppUserRoles.SuperAdmin}
                  path={AppRouteUi.Company.Root()}
                  component={PageCompany}
                />
                <PrivateRoute
                  role={AppUserRoles.Admin}
                  path={AppRouteUi.Finance.Patient()}
                  component={PageFinancePatient}
                />
                <PrivateRoute
                  role={AppUserRoles.Admin}
                  path={AppRouteUi.Finance.Caregiver()}
                  component={PageFinanceCaregiver}
                />
                <PrivateRoute
                  role={AppUserRoles.Admin}
                  path={AppRouteUi.Invoice.Root()}
                  component={PageInvoice}
                />
                <PrivateRoute
                  role={[AppUserRoles.Admin, AppUserRoles.SuperAdmin]}
                  path={AppRouteUi.Report.Root()}
                  component={PageReport}
                />
                <PrivateRoute
                  role={AppUserRoles.Admin}
                  path={AppRouteUi.Checkout.Root()}
                  component={PageCheckout}
                />
                <PrivateRoute
                  role={AppUserRoles.Admin}
                  path={AppRouteUi.Import.Root()}
                  component={PageImport}
                />
                <PrivateRoute
                  role={AppUserRoles.Admin}
                  path={AppRouteUi.Billing.Root()}
                  component={PageBilling}
                />
                <PrivateRoute
                  role={[AppUserRoles.Admin, AppUserRoles.SuperAdmin]}
                  path={AppRouteUi.DataExchange.Root()}
                  component={
                    AppUserRoles.SuperAdmin === userRole
                      ? PageSuperAdminDataExchange
                      : PageDataExchange
                  }
                />
                <PrivateRoute
                  role={[AppUserRoles.Admin, AppUserRoles.SuperAdmin]}
                  path={AppRouteUi.HHAConfig.Root()}
                  component={PageHHAConfig}
                />
                <Route path="**" component={PageNotFound} />
              </Switch>
            </main>
          </div>
        </div>
        <Footer />
      </div>
      <ModalsPrivateLayout />
    </RedirectToLoginOnUnauthorized>
  );
}
